import { cn } from '@/lib/tailwind-utils';
import { Loader2 } from 'lucide-react';

export const LoaderIcon = ({ className }: { className?: string }) => {
  return <Loader2 className={cn('h-10 w-10 text-primary animate-spin', className)} />;
};
